module.exports = __webpack_public_path__ + "img/Ornamen_Bulat_01.0a077e99.png";